'use client'

import { RadioOption } from '@/shared/types/radio-option'
import { ExpandableItems } from '@/shared/ui/expandable-items'
import { Radio } from '@/shared/ui/radio'

import styles from './expandable-radio-group.module.scss'

type ExpandableRadioGroupProps = {
	items: RadioOption[]
	value: string
	changeHandler?: (value: string) => void
	visibleRows?: {
		mobile?: number
		desktop?: number
	}
	showMobileScrollBar?: boolean
}

export const ExpandableRadioGroup = ({
	items,
	value,
	changeHandler,
	visibleRows,
	showMobileScrollBar
}: ExpandableRadioGroupProps): JSX.Element => {
	return (
		<ExpandableItems visibleRows={visibleRows} showMobileScrollBar={showMobileScrollBar}>
			<Radio.Group
				className={styles.group}
				value={value}
				onChange={e => changeHandler?.(e.target.value)}
				buttonStyle="solid">
				{items.map(item => (
					<Radio.Button value={item.value} key={item.value} className={styles.radioButton}>
						{item.label}
					</Radio.Button>
				))}
			</Radio.Group>
		</ExpandableItems>
	)
}
